var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uCalendar: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-calendar/u-calendar" */ "uview-ui/components/u-calendar/u-calendar.vue"
      )
    },
    uPicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-picker/u-picker" */ "uview-ui/components/u-picker/u-picker.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = true
    }
    _vm.e1 = function ($event) {
      _vm.show1 = true
    }
    _vm.e2 = function ($event, index) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        index = _temp2.index
      var _temp, _temp2
      return _vm.form.multifileList.splice(index, 1)
    }
    _vm.e3 = function ($event) {
      _vm.viewStatus = !_vm.viewStatus
    }
    _vm.e4 = function ($event) {
      _vm.show = false
    }
    _vm.e5 = function ($event) {
      _vm.show1 = false
    }
  }
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }